import { AwardGroup } from '../../models';
import { AwardGroupQueries } from '../../models/queries-type';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardGroups: (
  fetchContext: FetchContext, 
  awardGroupQueries?: AwardGroupQueries,
  accessToken?: string) => Promise<AwardGroup[]> = (fetchContext, awardGroupQueries, accessToken) => {
  const searchParams = new URLSearchParams();
  
  if (awardGroupQueries?.searchText) {
    searchParams.append('searchText', awardGroupQueries.searchText);
  }

  const url = `${fetchContext.baseUrl}/api/award-groups${
    searchParams.size > 0 ? `?${searchParams}` : ''
  }`;

  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<AwardGroup[]>(fetchContext.errorStore, response, 'get award groups'));
};
